// extracted by mini-css-extract-plugin
export var actionPlaceholder = "_8j-3";
export var contentContainer = "_8j-0";
export var editorContainer = "_8j-1";
export var quillInputForm = "_8j-2";
export var zoneDivider = "_8j-4";